import React, {useContext} from "react"

import Button from "../../../common/Button";
import EsiaAuth from "../ButtonsAction/EsiaAction"
import BuilderContext from "../../../../context/BuilderContext";
import {ExtraActionButBlock} from "../ButtonsAction/ExtraAction";
import { checkEmptyAuthMeta, CheckOptionON, ContractOptionMask } from "../../../../api/helper";

// отображает кнопки для выбора метода авторизации.
// можно отобразить хоть все за раз. для каждой кнопки нужно передать функцию активации перехода на форму авторизации
const ButtonsShowBlock = (props) => {
    const {interactive, external, options} = useContext(BuilderContext)

    if (checkEmptyAuthMeta(options)) {
        return(<>
            <Button
                    idPhrase={"btn_call"}
                    onClick={props.handlerCallAuthStart}
                    disabled={!interactive}
                />
        </>)
    }

    return (
        <>
            {
                external && 
                <ExtraActionButBlock 
                    start = {props.handlerExtraAuthStart}
                    setExternalUnit={props.setExternalUnit}
                    interactive={interactive} 
                    external={external} />
            }
            {
                CheckOptionON(options, ContractOptionMask.AuthSMS)  && <Button
                    idPhrase={"btn_sms"}
                    onClick={props.handlerSmsAuthStart}
                    text={"Войти с CMC"}
                    disabled={!interactive}
                />
            }
            {
                CheckOptionON(options, ContractOptionMask.AuthCall499) &&  <Button
                    idPhrase={"btn_call"}
                    onClick={props.handlerCallAuthStart}
                    disabled={!interactive}
                />
            }
            {
                CheckOptionON(options, ContractOptionMask.AuthCall800) &&  <Button
                    idPhrase={"btn_call"}
                    onClick={props.handlerCall800AuthStart}
                    disabled={!interactive}
                />
            }
            {
                CheckOptionON(options, ContractOptionMask.AuthPIN) &&  <Button
                    idPhrase={"btn_pin"}
                    onClick={props.handlerPinAuthStart}
                    disabled={!interactive}
                />
            }
            {
                CheckOptionON(options, ContractOptionMask.AuthMobileID) && <Button
                    idPhrase={"btn_mob_id"}
                    onClick={props.handlerMidAuthStart}
                    disabled={!interactive}
                />
            }
            {
                CheckOptionON(options, ContractOptionMask.AuthESIA) && <EsiaAuth disable={!interactive} />
            }
            {
                CheckOptionON(options, ContractOptionMask.AuthVoip) &&  <Button
                    idPhrase={"btn_call_voip"}
                    description={"Входящий звонок"}
                    onClick={props.handlerVoipAuthStart}
                    disabled={!interactive}
                /> 
            }
        </>
    )
}

export default ButtonsShowBlock;